<template>
  <v-app>
    <logged-in>
      <default-bar />
      <template v-slot:fallback>
        <non-dev-app-bar />
      </template>
    </logged-in>      
    <logged-in toggle>
      <slot name="drawer" />
    </logged-in>

    <logged-in>
      <v-main>
        <v-container fluid>
          <slot />
        </v-container>
      </v-main>      
      <template v-slot:fallback>
        <non-dev-view />
      </template>
    </logged-in>    

    <default-footer />

    <v-snackbar
      v-model="showFeedback"
      app
      bottom
      :color="$store.state.app.feedbackColor"
    >
      {{ $store.state.app.feedbackMessage }}
    </v-snackbar>
  </v-app>
</template>
<script>
  export default {
    name: 'PageLayout',

    components: {
      NonDevAppBar: () => import(        
        '@/layouts/NonDev/AppBar'
      ),
      NonDevView: () => import(        
        '@/layouts/NonDev/View'
      ),
      DefaultBar: () => import(
        /* webpackChunkName: "default-app-bar" */
        './AppBar'
      ),
      DefaultFooter: () => import(
        /* webpackChunkName: "default-footer" */
        './Footer'
      ),
    },
    computed: {
      showFeedback: {
        get () {
          return this.$store.state.app.displayFeedback
        },
        set (show) {
          this.$store.commit('app/displayFeedback', show)
        },
      },
    },
    mounted () {
    },
  }
</script>
